import React from 'react';
import { Image, Icon, Container } from 'semantic-ui-react';
import { useDispatch, useSelector } from 'react-redux';
import { editPortalSettingModal } from '../../../../actions/modal';
import { setSelectedPortalSettingValue } from '../../../../actions/portalSetting';
import SearchContainer from './searchContainer';
import { Media } from '../../../../mediaSetting';
import ScrollToTopButton from '../../../shared/scrollToTopBtn/content';
const CenterPanel = (props) => {
  const dispatch = useDispatch();
  const portalSettingLoader = useSelector((state) => state.portalSettingReducer.portalSettingLoader);

  const editPortalSetting = (portalSetting) => {
    dispatch(setSelectedPortalSettingValue(portalSetting));
    dispatch(editPortalSettingModal(true));
  };

  const getLoadingRows = () => {
    let loadingRows = '';

    // if (!props.portalSettings || props.portalSettings.length == 0) {
    if (portalSettingLoader) {
      //if we are fetching org units, then render this placeholder
      loadingRows = [0, 1].map((o, i) => {
        //this allows us to return 2 divs without a wrapper
        return (
          <div key={i} className="row flexible row-hoverable row-loading border-bottom">
            <div className="ui seven wide column  left-column-fixed left-text column bold  color-gray color-gray-bg pdnull  pdtnull " />

            <div className=" ui two wide computer only two wide tablet only column">
              <div className="ui active inverted dimmer " data-show={o == 0}>
                <div className="ui text loader mrtl " />
              </div>
            </div>

            <div className="ui seven wide column   left-column-fixed left-text column bold  color-gray color-gray-bg pdnull  pdtnull " />
            <div className="ui active inverted dimmer ">
              <div className="ui text loader  show-on-small-ress mrts" data-show={o == 0} />
            </div>
          </div>
        );
      });
    }
    if (!portalSettingLoader && (!props.portalSettings || props.portalSettings.length == 0)) {
      return (
        <div className="row flexible row-hoverable">
          <div className="column text-size-ml max-width center aligned content">
            {APP.LANGUAGE.ManageAllUsers.NoResults}
          </div>
        </div>
      );
    }
    return loadingRows;
  };

  const tableHeaderMarkup = (
    <div className="row flexible color-secondary pdtnull pdbnull header-row">
      {/* Column #1 header */}
      <span className="ui seven wide tablet  seven wide computer  eight wide mobile  column  icon input color-white hand display-flex">
        <SearchContainer
          style={{ lineHeight: '1.6em' }}
          onChange={props.handleSearchTerm}
          value={props.searchTerm}
          id="searchBarInputMR"
          className="ui color-white input color-meeting-room-bg-highlight max-width pdxs"
          maxlength="500"
          placeholder={APP.LANGUAGE.OrganisationalUnitManageUsers.ColumnHeader1Title}
          autoComplete="not-enable"
        />
        <i className="filter  icon mrrml" />
      </span>
      {/* Column #2 header */}
      <span className="ui nine wide tablet only nine wide computer only eight wide mobile column color-white display-flex">
        <div className={'color-white max-width pdxs left-text ' + props.isOnMobileOrTablet ? '' : 'pdlnull'}>
          {APP.LANGUAGE.WaitingAreaManageTags.ColumnHeader2Title}
        </div>
      </span>
    </div>
  );

  const renderPortalSettingRows = (myRoles, gray) => {
    let iterator = myRoles;
    if (iterator) {
      return iterator.map((portalSetting, i) => {
        let portalSettingsId = portalSetting.id;
        let removedClassName = portalSetting.isDeleted == true ? ' deleteRow ' : '';

        return (
          <div
            className={'row flexible row-hoverable border-bottom whiteBackGround' + removedClassName}
            data-opaque={!!gray}
            key={portalSettingsId}
            data-show={
              (props.saveIntermediateClick == true && portalSetting.isDeleted == true) || !props.saveIntermediateClick
            }
          >
            {/* for computer only */}
            <div className={'ui seven wide computer only  left-text column centerAlignVertical wrap-link '}>
              {portalSetting.name}
              <br />{' '}
            </div>
            <div className={'ui  seven wide  computer only  column centerAlignVertical  wrap-link'}>
              {portalSetting.currentValue}
            </div>

            {/* for tablet and mobile */}
            <div className={'ui thirteen wide tablet mobile only  left-text column centerAlignVertical  wrap-link '}>
              {portalSetting.name}
              <br />
              <div className={'mobileSecondRow   text-size-ms ' + removedClassName}>{portalSetting.currentValue}</div>
            </div>

            <div className={'ui one wide  centerAlignIcons '} onClick={() => editPortalSetting(portalSetting)}>
              <Icon name="edit" className="removeIcon" />
            </div>
          </div>
        );
      });
    }
  };

  let portalSettingMatchingSearchTermMarkup = '';
  let portalSettingNotMatchingSearchTermMarkup = '';

  if (props.portalSettings && props.portalSettings.length > 0) {
    const sortedPortalSettingList = props.portalSettings;
    let portalSettingMatchingSearchTerm = sortedPortalSettingList;
    let portalSettingNotMatchingSearchTerm = [];
    const searchTerm = props.searchTerm;
    console.log(`searchTerm`, searchTerm);
    if (searchTerm && searchTerm.trim().length > 0) {
      // do the filtering
      const searchTermLowerCase = searchTerm?.toLowerCase();
      portalSettingMatchingSearchTerm = [];
      portalSettingNotMatchingSearchTerm = [];

      sortedPortalSettingList.forEach((portalSetting) => {
        if (
          portalSetting.name?.toLowerCase().indexOf(searchTermLowerCase) > -1 ||
          portalSetting.organisationAbbreviatedName?.toLowerCase().indexOf(searchTermLowerCase) > -1 ||
          portalSetting.role?.toLowerCase().indexOf(searchTermLowerCase) > -1
        )
          portalSettingMatchingSearchTerm.push(portalSetting);
        else {
          portalSettingNotMatchingSearchTerm.push(portalSetting);
        }
      });
    }
    portalSettingMatchingSearchTermMarkup = renderPortalSettingRows(portalSettingMatchingSearchTerm, false);
    portalSettingNotMatchingSearchTermMarkup = renderPortalSettingRows(portalSettingNotMatchingSearchTerm, true);
  }
  return (
    <div>
      <Container fluid as={Media} lessThan="computer" className="ui center aligned padded grid">
        {tableHeaderMarkup}
        {getLoadingRows()}
        {portalSettingMatchingSearchTermMarkup}
        {portalSettingNotMatchingSearchTermMarkup}
      </Container>
      <Container fluid className="ui center aligned padded grid" as={Media} greaterThanOrEqual="computer">
        {tableHeaderMarkup}
        <div className="desktop-scrolling-wrapper max-width pdlnull pdrnull">
          <div className="ui center aligned padded grid pdlnull pdrnull" id="desktop-scrolling-wrapper-users">
            {
              <div className="row flexible row-hoverable" /> /* Have to add this empty div with .row class, to show the bottom border for other rows */
            }
            {getLoadingRows()}
            {portalSettingMatchingSearchTermMarkup}
            {portalSettingNotMatchingSearchTermMarkup}
          </div>
          <ScrollToTopButton className="scroll-top-btn-mobile" targetElement=".desktop-scrolling-wrapper-users" />
        </div>
      </Container>
    </div>
  );
};

export default CenterPanel;
